/**
 * Code Analysis - 자동완성 API
 */
import { langServerClient } from '@/shared/api/langserver/client';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { AnalysisRequest, CompletionItem } from './types';

export const fetchCompletions = async (
  target: ModuleTarget = 'run',
  payload: AnalysisRequest
): Promise<CompletionItem[]> => {
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const response = await langServerClient.post<CompletionItem[]>(
        `/${target}/api/v1/analysis/template/complete`,
        payload
      );
      return response.data;
    } catch (error) {
      if (attempt === 2) {
        console.error('Failed to fetch completions:', error);
        return [];
      }
      await new Promise((resolve) => setTimeout(resolve, 300 * (attempt + 1)));
    }
  }

  return [];
};
